import {
	connectProgressTracker,
	getImageInfo,
	getImageLayers,
	getStitchedLayers,
	getViewLevelsInfo,
	imageLoader,
	isZoomForTiled,
	locateAnnotationOnMap
} from "./utils/map_utils";
import {checkNotificationOpen, degreeToRadian, isNull, notNull} from "../../utils/utils";

import Static from "ol/source/ImageStatic";
import {bloodClass, mapLayerTypes, scanSpeed} from "../../utils/const";
import ImageLayer from "ol/layer/Image";
import BaseSlideMap from "./BaseSlideMap";
import {closeNotification, notifyInfo} from "./utils/display.notification";
import {store} from "../../helper/store";
import {updateAllGridsWBC} from "../../redux_actions/wbcview.action";

import {toggleBloodMap, updateImageLoadProgress} from '../../redux_actions/gamma.state.action';
import {updateAnnotationsBlood, updateAnnotationState} from "../../redux_actions/maps.state.action";
import {bloodAnnoStopMove} from "../../redux_actions/bloodGrid.action";
import {filterAnnotationsInROI, markAnnotation} from "./utils/annotations_app_utils";
import {updateAllGrids} from "../../redux_actions/fieldView.action";

class Slidemap extends BaseSlideMap {

	unit = "pixels";
	metersPerUnit = this.props.slide.uperpixel / 1e6;
	key = `slide-map-${this.props.id}`;
	disableRotate = false;

	componentDidMount() {
		super.componentDidMount();
		this.map.addEventListener('moveend', this.updateLayers);
        if (this.props.slide.scan_speed === scanSpeed.ZSTACK) {
            this.map.addEventListener('moveend', this.cacheZStackLayers);
        }
		this.updateLayers();
		this.notifyZStack();
		this.props.bloodMapEnable && store.dispatch(toggleBloodMap(this.props.bloodMapEnable));
		this.props.bloodMapEnable && this.fetchAnnotations();

		connectProgressTracker(
			this.map,
			(progress) => store.dispatch(updateImageLoadProgress(progress))
		)
	}

	componentWillUnmount() {
		store.dispatch(toggleBloodMap(false));
		if(this.props.slide.scan_speed === scanSpeed.ZSTACK){
			this.map.removeEventListener('moveend', this.updateLayers);
		}
		super.componentWillUnmount();
	}

	notifyZStack = () => this.props.slide?.meta?.takeZStack &&
		notifyInfo('zStackNotification',
			<h4>
				Slides with ZStack Layers detected
				<br/>
				Use SHIFT + Mouse Scroll Wheel to navigate between Z-Stack Layers
			</h4>, false, 0);


	componentDidUpdate(prevProps, prevState, snapshot) {
		let rotation = this.props.displaySetting?.rotation;
		if (!this.disableRotate && prevProps.displaySetting?.rotation !== rotation && notNull(rotation)){
			this.map.getView().setRotation(degreeToRadian(rotation));
		}

		if (prevProps.exposure !== this.props.exposure)
			this.map.getLayers().getArray().forEach(layer =>
				layer.setVisible(layer.values_.exposure === this.props.exposure || (layer.values_.name !==
					mapLayerTypes.TILED_LAYER_NAME && layer.values_.name !== mapLayerTypes.STITCHED_LAYER_NAME && layer.getVisible())));

		if (prevProps.zStackLevel !== this.props.zStackLevel) {
			this.map.getLayers().getArray().forEach(layer => {
				const visibility = layer.values_.posS === this.props.zStackLevel || (!(layer instanceof ImageLayer) && layer.getVisible())
				visibility && layer.values_.zIndex < 0 && layer.setZIndex(-1 * layer.getZIndex());
				layer.setVisible(visibility)
			});
		}

		if (checkNotificationOpen('zStackNotification') && this.state.shiftScrollCount > 10)
			closeNotification('zStackNotification');

		if (prevProps.slide.txty !== this.props.slide.txty) {
			this.updateLayers()
		}


		if (this.props.bloodMapEnable) {
			if (isNull((prevProps.annotationState || {}).annotations) && notNull((this.props.annotationState || {}).annotations))
				this.fetchAnnotations();

			if ((prevProps.mode !== this.props.mode) || (prevProps.wbcGridData.differential_confirmed !== this.props.wbcGridData.differential_confirmed) ||
				(prevProps.wbcGridData || {}).tag !== (this.props.wbcGridData || {}).tag ||
				((prevProps.wbcGridData || {}).update_summary === false && (this.props.wbcGridData || {}).update_summary === true) ||
				((prevProps.wbcGridData || {}).selected_grid.length === 0 && (this.props.wbcGridData || {}).selected_grid.length !== 0) ||
				((prevProps.wbcGridData || {}).selected_grid.length !== 0 && (this.props.wbcGridData || {}).selected_grid.length === 0) ||
				(prevProps.wbcGridData || {}).all_grids !== (this.props.wbcGridData || {}).all_grids) {
				this.fetchAnnotations();
			}

			if (this.props?.pltGridData?.selected_grid !== '' && prevProps.pltGridData?.selected_grid !== this.props.pltGridData?.selected_grid) {
				const annotation = this.props.pltGridData.selected_grid;
				this.drawBloodAnnotation(annotation).then(() => {
					markAnnotation(this.props.activeMapId, annotation);
					locateAnnotationOnMap(this.map, annotation, true);
				});
			}

			if (this.props?.rbcGridData?.selected_grid !== '' && prevProps.rbcGridData?.selected_grid !== this.props.rbcGridData.selected_grid) {
				const annotation = this.props.rbcGridData.selected_grid;
				this.drawBloodAnnotation(annotation).then(() => {
					markAnnotation(this.props.activeMapId, annotation);
					locateAnnotationOnMap(this.map, annotation, true);
				});
			}

			if (this.props.bloodGridData.selected === true && this.props.bloodGridData.move === true) {
				let center = JSON.parse(this.props.bloodGridData.selected_anno.center);
				if (this.props.bloodGridData.class === bloodClass.WBC) {
					let extent = this.map.getView().calculateExtent(this.map.getSize())//ignoring zoom for now
					let heightOffset = Math.abs(extent[3] - extent[1]) / 2;
					let widthOffset = Math.abs(extent[2] - extent[0]) / 2;
					let finalExtent = [center[0] - widthOffset, center[1] - heightOffset, center[0] + widthOffset, center[1] + heightOffset]
					let val = {
						id: this.props.slideId,
						extent: finalExtent,
						tag: this.props.bloodGridData.tag
					}
					let url = `/api/get_extent_all_annotations/`;
					updateAnnotationsBlood(bloodClass.WBC, this.props.id, this.props.slideId, url, val, () => {
					})
				} else {
					store.dispatch(updateAnnotationState(this.props.id, {
						annotations: [this.props.bloodGridData.selected_anno],
					}))
				}
				store.dispatch(bloodAnnoStopMove());
			}
		}
	}

	updateBloodAnnotationState = (annotation) => {
		if (this.props.mode === bloodClass.WBC || this.props.mode === bloodClass.FIELD) {
			store.dispatch(updateAnnotationState(this.props.id, {
				annotations: filterAnnotationsInROI(annotation),
			}));
		} else {
			store.dispatch(updateAnnotationState(this.props.id, {
				annotations: [annotation],
			}));
		}
	}

	drawBloodAnnotation = (annotation) => new Promise((resolve, reject) => {
		this.updateBloodAnnotationState(annotation);
		resolve();
	});

	fetchAnnotations = () => {
		if (this.props.mode === bloodClass.WBC) {
			if (this.props.wbcGridData.selected_grid === '') {
				store.dispatch(updateAnnotationState(this.props.id, {
					annotations: [],
				}));
				return;
			}
			this.updateBloodAnnotationState(this.props.wbcGridData.all_grids);
			store.dispatch(updateAllGridsWBC(this.props.wbcGridData.all_grids))
		} else if (this.props.mode === bloodClass.FIELD) {
			if (this.props.fieldGridData.all_grids && this.props.fieldGridData.all_grids.length !== 0) {
				const annotation = this.props.fieldGridData.all_grids;
				this.updateBloodAnnotationState(annotation);
			} else if (notNull(this.props.annotationState) && notNull(this.props.annotationState.annotations)) {
				const annotation = this.props.annotationState.annotations.filter(annotation => annotation.anno_drawer === 4)
					.sort((annotation1, annotation2) => annotation1.id - annotation2.id);
				this.updateBloodAnnotationState(annotation);
				store.dispatch(updateAllGrids(annotation));
			}
		} else {
			store.dispatch(updateAnnotationState(this.props.id, {
				annotations: [],
			}));
		}
	}


	// TODO: [Priyanshu] refactor this function
	updateLayers = () => {
		let {slide, zStackLevel, exposure} = this.props;

		let minZLevel = Math.floor(slide.meta?.takeBidirectionalZStack ? (-1 * ((slide?.meta?.numZLevels) / 2)) : 0);
		let maxZLevel = Math.floor(slide.meta?.takeBidirectionalZStack ? (slide?.meta?.numZLevels) / 2 : (slide?.meta?.numZLevels));

		let nextZoom = this.map.getView().getZoom();
		let viewport = this.map.getView().calculateExtent(this.map.getSize());

		let viewLevelsInfo = getViewLevelsInfo(slide);
		let imageInfo = getImageInfo(slide);

		let newLayers;

		if (isZoomForTiled(nextZoom, viewLevelsInfo)) {
			let tiledZoom = Math.min(Math.round(nextZoom) -
				(viewLevelsInfo.lastStitchedLevel - viewLevelsInfo.lastTiledLevel), viewLevelsInfo.lastTiledLevel);
			newLayers = getImageLayers(tiledZoom, imageInfo, slide, slide.txty, viewport, viewLevelsInfo.lastTiledLevel,
				zStackLevel, minZLevel, maxZLevel, slide.meta?.takeZStack, exposure, this.props.id);
			let allOldLayers = this.map.getLayers().getArray();

			let layersToRemove = [];

			for (let oi in allOldLayers) {
				let foundInNewLayers = false;
				let layerFoundAtIndex = -1;
				let oldLayer = allOldLayers[oi];

				for (let i = 0; i < newLayers.length; i++) {
					let newLayer = newLayers[i];
					if (oldLayer.values_.posI === newLayer.values_.posI && oldLayer.values_.posJ === newLayer.values_.posJ
						&& oldLayer.values_.exposure === newLayer.values_.exposure) {
						if (oldLayer.values_.posZ !== newLayer.values_.posZ) {
							let oldUrlParts = oldLayer.getSource().getUrl().split('/');
							oldUrlParts[oldUrlParts.length - 2] = newLayer.values_.posZ;
							oldLayer.setSource(new Static({
								imageExtent: oldLayer.getSource().getImageExtent(),
								url: oldUrlParts.join('/'),
								imageSize: imageInfo.imageSizes[newLayer.values_.posZ],
								imageLoadFunction: (image, src) => imageLoader(image, src, this.props.slide.id, this.props.id),
								crossOrigin: 'anonymous',
							}));
							oldLayer.values_.posZ = newLayer.values_.posZ;
						}
						foundInNewLayers = true;
						layerFoundAtIndex = i;
					}
				}
				if (foundInNewLayers)
					newLayers.splice(layerFoundAtIndex, 1);
				else if (oldLayer.values_.name === mapLayerTypes.TILED_LAYER_NAME)
					layersToRemove.push(oldLayer);
				else if (oldLayer instanceof ImageLayer) {
					oldLayer.setVisible(false);
				}
			}

			layersToRemove.reverse();

			newLayers.forEach(layer => this.map.addLayer(layer));

			layersToRemove.forEach(layer => this.map.removeLayer(layer));


		} else {
			let stitchedLayerExists = false;
			let layersToRemove = [];

			this.map.getLayers().getArray().forEach(oldLayer => {
				if (oldLayer.values_.name === mapLayerTypes.STITCHED_LAYER_NAME) {
					stitchedLayerExists = true;
					oldLayer.setVisible(oldLayer.values_.exposure === exposure);
				} else if (oldLayer.values_.name === mapLayerTypes.TILED_LAYER_NAME) {
					layersToRemove.push(oldLayer);
				}
			});

			layersToRemove.reverse();

			layersToRemove.forEach(layer => this.map.removeLayer(layer));

			!stitchedLayerExists && getStitchedLayers(slide, this.props.id, this.map.getView().getProjection(), exposure)
				.forEach(layer => this.map.addLayer(layer))
		}
	}

	cacheLayer = (layers, zLevel) => {
		for (let i = 0; i < layers.length; i++) {
			let layer = layers[i];
			if (layer.values_.posS === (-1 * zLevel) || layer.values_.posS === zLevel) {
				if(layer.values_.posS != this.props.zStackLevel) {
					let currZIndex = layer.getZIndex();
					layer.setZIndex(-1 * currZIndex);
				}
				layer.setVisible(true);
			}
		}
		setTimeout(() => this.layerVisibilityOff(layers, zLevel), 10);
		this.upperZLevelsCached = this.upperZLevelsCached + 1;
		this.lowerZLevelsCached = this.lowerZLevelsCached - 1;
	}

	cacheZStackLayers = () => {
		this.upperZLevelsCached = 0;
		this.lowerZLevelsCached = 0;
		let maxZLevel = this.props.slide?.meta?.takeBidirectionalZStack ? (this.props.slide?.meta?.numZLevels - 1) / 2 :
			(this.props.slide?.meta?.numZLevels - 1);
		let timerInterval = 1000;
		let timer = 0;
		for (let i = 0; i <= maxZLevel + 1; i++) {
			let layers = this.map.getLayers().getArray();
			setTimeout(() => this.cacheLayer(layers, i), timer);
			timer += timerInterval;
		}
	}

	layerVisibilityOff = (layers, zLevel = null) =>
		layers.forEach(layer => {
			layer.setVisible((!(layer instanceof ImageLayer) && layer.getVisible()) || layer.values_.posS === this.props.zStackLevel);

			let currZIndex = layer.getZIndex();
			if (zLevel && currZIndex < 0 && (layer.values_.posS === (-1 * zLevel) || layer.values_.posS === zLevel)) {
				layer.setZIndex(-1 * currZIndex)
			}
		});

	cacheZoomLevels = (upper, layers) => {
		let maxZLevel = this.props.slide?.meta?.takeBidirectionalZStack ? (this.props.slide?.meta?.numZLevels - 1) / 2 :
			(this.props.slide?.meta?.numZLevels - 1);
		if (upper && this.upperZLevelsCached < maxZLevel) {
			for (let i = 0; i < layers.length; i++) {
				let layer = layers[i];
				if (layer.values_.posS === (this.upperZLevelsCached + 1) ||
					layer.values_.posS === (this.upperZLevelsCached + 2)) {
					layer.setVisible(true);
				}
			}
			setTimeout(() => this.layerVisibilityOff(layers), 10);
			this.upperZLevelsCached = this.upperZLevelsCached + 2;
		} else if (!upper && this.lowerZLevelsCached > (-1 * maxZLevel)) {
			for (let i = 0; i < layers.length; i++) {
				let layer = layers[i];
				if (layer.values_.posS === (this.lowerZLevelsCached - 1) || layer.values_.posS === (this.lowerZLevelsCached - 2)) {
					layer.setVisible(true);
				}
			}
			setTimeout(() => this.layerVisibilityOff(layers), 10);
			this.upperZLevelsCached = this.lowerZLevelsCached - 2;
		}
	}
}

export default Slidemap;
